import { useCallback } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';

import type { UrlTilePayload } from '../types';

export const useUnavailableTilePayloadWarning = (
    declaredTypes: ReadonlySet<string>,
): ((payload: UrlTilePayload) => void) => {
    const { logger } = useApplicationContext();

    return useCallback(
        (payload: UrlTilePayload) => {
            if (declaredTypes.has(payload.type)) {
                return;
            }

            logger?.warn(`[url-tiles] tile type "${payload.type}" is not declared for the current route`);
        },
        [declaredTypes, logger],
    );
};
